<p-listbox
  [options]="unitList$ | async"
  optionLabel="unitName"
  [filter]="true"
  [listStyle]="{
    display: 'block',
    height: 'calc(100% - 51px)',
    border: 'none',
    'font-size': '0.8rem'
  }"
  [styleClass]="'d-block h-100 border border-0'"
  class="h-100 d-block"
  [emptyMessage]="'Sin unidades'"
  [emptyFilterMessage]="'Unidad no encontrada'"
  [filterPlaceHolder]="'Buscar unidad ..'"
>
  <ng-template let-item pTemplate="item">
    <div class="">
      <div
        [pTooltip]="
          item.GNSSIMEI.charAt(0).toString() +
          ' - ' +
          item.hasIgnition.toString() +
          ' - ' +
          item.currentSpeed.toString() +
          ' - ' +
          item.elapsedTime.toString() +
          ' - ' +
          item.batteryVoltage.toString() +
          ' - ' +
          item.powerVoltage.toString() +
          ' - ' +
          item.device.satelliteCount.toString() +
          ' - ' +
          item.device.trackerDate.toLocaleString()
        "
        tooltipPosition="top"
      >
        {{ item.unitName }}
      </div>
    </div>
  </ng-template>
</p-listbox>
